import { NgModule, ModuleWithProviders, inject } from '@angular/core';
import { SphereAINewsAPIConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AuditService } from './api/audit.service';
import { HealthService } from './api/health.service';
import { IntelligenceService } from './api/intelligence.service';
import { MarketScanService } from './api/marketScan.service';
import { ModelService } from './api/model.service';
import { UserService } from './api/user.service';

@NgModule({
    imports: [],
    declarations: [],
    exports: [],
    providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => SphereAINewsAPIConfiguration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [{ provide: SphereAINewsAPIConfiguration, useFactory: configurationFactory }]
        };
    }

    constructor() {
        const parentModule = inject(ApiModule, { optional: true, skipSelf: true })!;
        const http = inject(HttpClient, { optional: true })!;

        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error(
                'You need to import the HttpClientModule in your AppModule! \n' + 'See also https://github.com/angular/angular/issues/20575'
            );
        }
    }
}
